<template>
	<sf-modal-layout class="qms-cmpn" :title="campaignPopupInfo.title" :show="display" :closeModal="close">
		<div class="sf-flex-column h-100">
			<template v-if="!isLoading">
				<sf-card class="p-0 border-0 bg-transparent">
					<campaign-popup-table
						ref="tableInfo"
						:scrId="scrId"
						:sendParam1="sendParam1"
						@Refresh="Refresh"
						@OpenCmpnPopup="OpenCmpnPopup"
					></campaign-popup-table>
				</sf-card>
			</template>
		</div>
		<!--업체명 팝업-->
		<comp-popup ref="compPopup" @SendData="sendData1" @Refresh="Refresh" :scrId="scrId"></comp-popup>
	</sf-modal-layout>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/qlty/Campaign/store/helpers';

import CampaignPopupTable from './Table/CampaignPopupTable.vue';
import CompPopup from '@/views/qms/comm/commpopup/CompPopup/CompPopup.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		//해당 컴포넌트안에서 사용하는 상태 정의(지역변수)
		return {
			display: false,
			isLoading: false,
			campaignPopupInfo: {
				title: '', //타이틀명
				cmpnNo: ''
			},
			sendParam1: {} //업체명팝업
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	components: {
		CampaignPopupTable,
		CompPopup
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		Refresh() {
			this.$emit('Refresh');
		},
		async open(param) {
			this.display = true;
			this.isLoading = true;
			this.$sf_toggleLoading(true);

			this.campaignPopupInfo.title = param.title;
			this.campaignPopupInfo.cmpnNo = param.cmpnNo;
			let campaignPopupInfo = this.campaignPopupInfo;

			await this.setCampaignInfoInit_();

			try {
				await this.getCampaignInfo_(campaignPopupInfo);
			} catch (error) {
				
				this.$sf_toast({
					type: 'error',
					message: error.message
				});
			} finally {
				this.isLoading = false;
				this.$sf_toggleLoading(false);
			}
			//초기화

			this.isLoading = false;
			this.$sf_toggleLoading(false);
		},
		close() {
			this.$emit('Refresh');
			this.isLoading = true;
			this.display = false;
		},
		OpenCmpnPopup(param) {
			this.$refs.compPopup.open(param); //.open(param);
		},
		sendData1(param) {
			this.sendParam1 = param;
		}
	},
	created() {
		console.clear();
	}
};
</script>

<style></style>
